import './App.css';
import Searchbar from "./components/searchbar/searchbar";
import Selectbar from "./components/selectbar/selectbar";
import LoaderScreen from "./components/LoaderScreen/LoaderScreen";
import GeolocationButton from "./components/geolocation/geolocation";
import StoreListItem from "./components/storesList/storeListItem";
import useFetch from "use-http";
import {getDistance} from "geolib";
import React , {useCallback, useEffect, useState,useRef,Suspense} from "react";
import Filters from "./components/filters/filters";
import textJson from './text/text.json'
import useSettings from "./hooks/useSettingsApi";
import {useDataInit} from "./hooks/useDataInit";
import Flaticon from "./components/flaticon/flaticon";

function App() {

    // Get plugin settings from WP "Localize"
    const settings = useSettings();


    // Custom text vars
    const singular_text = settings ? settings.singular ? settings.singular : textJson.singular_text : textJson.singular_text
    const plural_text = settings ? settings.plural ? settings.plural : textJson.plural_text : textJson.plural_text
    const openOnlyStore = `Afficher les ${plural_text} ouverts en ce moment`

    // Get Stores data from WP API
    const {
        data : dataInit,
        filter : filterTag,
        loading,
        error
    } = useDataInit()

    // Init location search fetch api (api-adresse.data.gouv.fr)
    const {
        get: getSearch,
        response: responseSearch,
        loading: loadingSearch,
        error: errorSearch
    } = useFetch('https://api-adresse.data.gouv.fr/search/')


    /* INIT STATES */
    // Stores data states
    const [dataHistory, setDataHistory] = useState(false)
    const [dataFiltered, setDataFiltered] = useState([])

    // Store the current user action
    const [currentAction,setCurrentAction] = useState(false);

    // Store the current searched text
    const [searchedText,setSearchedText] = useState(false);

    // Add to active filter list
    //const [extraActiveFilter,setExtraActiveFilter] =

    // Filters list states
    const [dataFilterTag, setDataFilterTag] = useState([])
    const [activeFilterList, setActiveFilterList] = useState([])

    // Location states
    const [nearLocation, setNearLocation] = useState(false)
    const [haveLocation, setHaveLocation] = useState(false)
    const [coords, setCoords] = useState(false)


    // Range state
    const [rangeValue, setRangeValue] = useState(false)
    const [isResetable, setIsResetable] = useState(false)

    // Scroll to stores list
    const scrollTo = useRef(null)
    const executeScroll = () => {
        const yOffset = -150;
        const y = scrollTo.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    /**
     * Load Initial stores list and get user geolocation to fill near store location list
     * @returns {Promise<void>}
     */
    const loadInitialStores = async () => {

        // If data fetched
        if (dataInit) {

            // add a new filter in the filters list
            const filterTagAdded = addFilterTag([{label:openOnlyStore,checked:false}]);

            // Update filter list and precise the new added filter
            filterData(dataInit,[],filterTagAdded)

            // Fill the dataHistory with the initial data
            setDataHistory(dataInit)

            // Get user current location and coord to fill nearLocation state
            navigator.geolocation.getCurrentPosition((e) => {

                // Check if coords are set
                if (e.coords && e.coords.latitude){
                    // Fill coords state with got coords from user
                    setCoords(e.coords);

                    // Set haveLocation state to true
                    setHaveLocation(true);

                    // Fill nearLocation state with the closest stores from user location
                    setNearLocation(
                        dataInit.filter(
                            ((object, index) => {
                                // Get the distance between the current store
                                // in dataInit coords and the user coords
                                const distance = getDistance(
                                    {latitude: e.coords.latitude, longitude: e.coords.longitude},
                                    {latitude: object.sl_lat, longitude: object.sl_lng}
                                )
                                dataInit[index].sl_distance = distance
                                return distance < (rangeValue ? rangeValue : 10) * 1000
                            })
                        )
                    )
                }

                // Sort data by distance
                dataInit.sort((a,b) => a.sl_distance - b.sl_distance)

            });

            return dataInit;
        }
    }

    /**
     * Check if an element is in a defined array
     * @param data
     * @param array
     * @param key
     * @returns {boolean}
     */
    const isInArray = (data = [], array = [], key = false) => {
        let result = false
        if (array)
            array.forEach((element, i) => {
                const dataTest =
                    data.findIndex((subElement) => {
                        if (key) {
                            return subElement.label === element[key].toLowerCase()
                        } else {
                            return subElement.label === element.toLowerCase()
                        }

                    })
                if (dataTest !== -1 && typeof dataTest !== "undefined")
                    result = true;
            })
        return result
    }

     /**
     * Get searched value from the stores list
     * @param q
     * @param needFetch
     * @param filter
     * @param action
     * @param keepHistory
     * @returns {Promise<void>}
     */
    async function loadSearch(q, needFetch = true, filter = [],action=false,keepHistory=true) {
        //Do nothing while the initial datas aren't loaded
         executeScroll()
        if (dataInit.length !== 0) {
            //Get searched location infos if needFetch is true
            const search = needFetch ? await getSearch(`?q=${q}`) : false
            setSearchedText(q)
            //Update store list with searched value by title, address and distance if needFetch is true
            const nearSearch = dataInit.filter((object) => {
                let distance = ((rangeValue ? rangeValue : 10) * 1000) + 1
                if (responseSearch.ok && needFetch) {
                    if (search.features.length !== 0) {
                        distance = getDistance(
                            {
                                latitude: search.features[0].geometry.coordinates[1],
                                longitude: search.features[0].geometry.coordinates[0]
                            },
                            {latitude: object.sl_lat, longitude: object.sl_lng}
                        )
                    }
                    executeScroll()
                }

                const labelMatch = object.sl_address.toLowerCase().search(q.toLowerCase())
                const nameMatch = object.title.rendered.toLowerCase().search(q.toLowerCase())
                return distance < (rangeValue ? rangeValue : 10) * 1000 || labelMatch !== -1 || nameMatch !== -1
            })
            filterData(nearSearch, filter,false,action)
            //Keep data searched in memory if true
            if (keepHistory)
                setDataHistory(nearSearch);


        }
    }

    const filterOpenStores = (data,activeList) => {
        if (activeList.findIndex((e)=>e.label === openOnlyStore) !== -1){
            return data.sl_today_schedule ? data.sl_today_schedule.open_now : false
        } else {
            return true;
        }
        return false;
    }
    /**
     * set dataFiltered state with filtered data
     * @param data list of data that will be filtered in the function
     * @param listOfActiveFilter list of current checked and activated filters
     * @param listOfFilter list of all available filters
     * @param action the current action done that need the data filtering
     */
    const filterData = (data, listOfActiveFilter = [],listOfFilter = false,action=false) => {

        setCurrentAction(action)

        if (listOfActiveFilter.length !== 0) {

            //Filter by opened stores
            const filteredOpenStores = data.filter((element)=>{
                return filterOpenStores(element,listOfActiveFilter);
            })

            //Filter by deliveries list
            const filteredData = filteredOpenStores.filter((element, i) => {
                return isInArray(listOfActiveFilter, element.sl_hook[1].content, 'title')
            })

            setDataFiltered(
                filteredData.length !== 0 ? filteredData : filteredOpenStores
            )
            updateFilterTagCount(filteredData.length !== 0 ? filteredData : filteredOpenStores,!listOfFilter ? dataFilterTag : listOfFilter)
        } else {
            setDataFiltered(data)
            updateFilterTagCount(data,!listOfFilter ? dataFilterTag : listOfFilter)
        }
    }

    const updateFilterTagCount = (filteredArray,listOfFilter) => {
        let deliveriesFilter = listOfFilter
        //Reset deliveries count to 0
        deliveriesFilter.forEach((e,i)=>{
            if (typeof deliveriesFilter[i].count !== "undefined")
                deliveriesFilter[i].count = 0
        })

        // Re count current deliveries in the list
        filteredArray.forEach((object, index) => {
            if (object.sl_hook[1].content) {
                object.sl_hook[1].content.forEach((subobject, subindex) => {
                    const deliveriesFilterIndex = deliveriesFilter.findIndex(element => element.label === subobject.title.toLowerCase())
                    if ( deliveriesFilterIndex !== -1) {
                        deliveriesFilter[deliveriesFilterIndex].count++
                    }
                })
            }
        })
        setDataFilterTag(deliveriesFilter)
    }

    const addFilterTag = (filters) => {
        let newFilter = filterTag;
        let checkedFilter = [];
        filters.forEach((object)=>{
            if (object.checked){
                checkedFilter.unshift({label : object.label})
            }
            if (!object.count)
                newFilter.unshift({label:object.label});
            else
                newFilter.unshift({label:object.label,count:object.count});
        })


        setDataFilterTag(newFilter)

        if (checkedFilter.length !== 0){
            setActiveFilterList(checkedFilter)
            filterData(dataInit,checkedFilter)
        }

        return newFilter
    }

    const activateFilter = (filterLabel,filterName=false,updateLabel=false) => {

        if (!filterName && !updateLabel){
            setActiveFilterList([...activeFilterList,{label:filterLabel}])
        } else {
            if (updateLabel){
                if (activeFilterList.findIndex((e)=>e.name === filterName) === -1)
                    setActiveFilterList([...activeFilterList,{name:filterName,label:filterLabel}])
                else
                    setActiveFilterList(activeFilterList.map((e)=>{
                        if (e.name === filterName)
                            e.label = filterLabel

                        return e
                    }))
            } else {
                setActiveFilterList([...activeFilterList,{name:filterName,label:filterLabel}])
            }
        }

    }

    const nearLocationUpdate = (range) => {
        if (coords){
            const locations = dataInit.filter(((object) => {
                const distance = getDistance(
                    { latitude: coords.latitude, longitude: coords.longitude },
                    { latitude: object.sl_lat, longitude: object.sl_lng }
                )
                return distance < parseInt(range)*1000
            }))
            setNearLocation(locations)

            return locations
        }

    }

    useEffect(() => {

        loadInitialStores().catch()

        return function reset() {
            setActiveFilterList([])
            setDataFilterTag([])
            setIsResetable(false)
        }
    }, [dataInit,filterTag])

    /**
     * Get near to user geolocation stores list
     * @param e
     */
    const handleGeolocationClick = (e) => {
        if (haveLocation && nearLocation) {
            setDataHistory(nearLocation)
            filterData(nearLocation, activeFilterList,false,'geolocate')
            setIsResetable(true)
            executeScroll()
        }
    }

    /**
     *
     */
    const handleResetGeolocationClick = () => {
        setIsResetable(false)
        filterData(dataInit, activeFilterList)
    }

    const handleSearchChange = (e) => {
    }

    /**
     * Update near to searched location stores list
     * @param e
     */
    const handleSearchSubmit = (e) => {
        e.preventDefault()
        if (e.target[0].value !== '') {
            setIsResetable(true)
            setDataHistory(nearLocation)
            loadSearch(e.target[0].value, true, activeFilterList,'search')
        }
    }

    /**
     * Update near to selected store list
     * @param e
     */
    const handleSelectChange = (e) => {
        e.preventDefault()
        if (e.target.value !== 'disable') {
            setIsResetable(true)
            loadSearch(e.target.value, false)
            executeScroll()
        } else {
            setDataFiltered(dataInit)
        }
    }

    /**
     * @param filter
     */
    const handleFilterClick = (filter) => {
        if (activeFilterList.findIndex(element => element.label === filter) === -1) {

            setActiveFilterList([...activeFilterList, {label : filter}])
            filterData(dataHistory, [...activeFilterList, {label : filter}],false,currentAction)

        } else {

            // Reset rangeValue when user desactivate range filter
            if (activeFilterList.findIndex(e=>e.label === filter && e.name === 'range') !== -1){
                setRangeValue(false)
                nearLocationUpdate(10)
            }

            setActiveFilterList(activeFilterList.filter((element) => (element.label !== filter)))
            filterData(isResetable ? dataHistory : dataInit , activeFilterList.filter((element) => (element.label !== filter)),false,currentAction)
        }
    }

    const handleRangeChange = (e) => {
        setRangeValue(e.target.value)
    }

    const handleRangeUp = (e) => {
        activateFilter(`Rayon ( ≈ ${rangeValue}km )`,'range',true)
        if (coords){

            const locations = dataInit.filter(((object) => {
                const distance = getDistance(
                    { latitude: coords.latitude, longitude: coords.longitude },
                    { latitude: object.sl_lat, longitude: object.sl_lng }
                )
                return distance < parseInt(e.target.value)*1000
            }))
            setNearLocation(locations)
            if (!currentAction || currentAction === 'geolocate'){
                filterData(locations,activeFilterList,false,'geolocate')
            }

        }
        if (currentAction === 'search'){
            loadSearch(searchedText, true, activeFilterList,'search',false)
        }

    }

    return (
        <div className="App">
            <div className={'header'}>
                <Searchbar className={'header-item'} handleSearchChange={handleSearchChange} isLoading={loadingSearch}
                           handleSearchSubmit={handleSearchSubmit} data={dataInit}/>
                <Selectbar haveLocation={haveLocation} className={'header-item'} defaultValue={''} handleSelectChange={handleSelectChange}
                           nearLocation={nearLocation} data={dataInit}/>
                <GeolocationButton haveLocation={haveLocation} range={rangeValue} className={'header-item'} handleGeolocationClick={handleGeolocationClick}
                                   handleResetGeolocationClick={handleResetGeolocationClick}/>

            </div>
            <div className={'under-header'}>
                <div className={'active-filter-list'}>
                    {
                        activeFilterList.length !== 0 ? activeFilterList.map((object,index) => {
                            return (
                                <div key={'active-filter-'+index} className={'active-filter-list-item'}>
                                    <div className={'active-filter-list-item-close'}>
                                        <button data-filter={object.label} onClick={e => {handleFilterClick(e.target.dataset.filter)}} >x</button>
                                    </div>
                                    <div className={'active-filter-list-item-text'}>{object.label[0].toUpperCase() + object.label.substring(1)}</div>
                                </div>
                            )

                        }) : ''
                    }
                </div>
                {isResetable ? <div className={'reset-geolocation'}><button onClick={handleResetGeolocationClick}
                                                                           className={'slo-btn'} type="button">{textJson.cancel_text}</button></div> : ''}
                <Filters rangeValue={rangeValue} handleRangeUp={handleRangeUp} handleRangeChange={handleRangeChange} dataFilterTag={dataFilterTag} handleFilterClick={e => {handleFilterClick(e.target.name)}}
                         activeFilterList={activeFilterList}/>
            </div>

            <div className={'top-body'}>
                <div className={"top-body-count"}><div className={'top-body-count-number'}>{dataFiltered.length}</div> <div className={'top-body-count-text'}>{dataFiltered.length > 1 ? plural_text+" trouvés" : singular_text+" trouvé"}</div></div>
            </div>

            <div className={'main'}>
                <div className={`storelist`} ref={scrollTo}>
                    {!loading && !error && dataFiltered.length !== 0 ?
                        <>
                            {loadingSearch ?
                                <div className={'full-loader-screen'}>
                                    <LoaderScreen/>
                                </div>

                                :
                                ''
                            }
                            {dataFiltered.map((e, i) => {
                                return (
                                    <StoreListItem  key={`StoreListItem-${i}`} geolocation={'geolocation'} data={e}/>
                                )
                            })}
                        </>

                                : <div className={"notification-box"}>{
                                    loading ?
                            <LoaderScreen/>
                            : error ?
                                <>
                                    <Flaticon icon={'close'}/>
                                    {textJson.error_text+error}
                                </>
                                 :
                                <>
                                    <Flaticon icon={'close'}/>
                                    {textJson.no_result_text}
                                </>

                                }</div>

                    }
                </div>

            </div>
        </div>
    );
}

export default App;
